
import { css } from 'lit';
export default css`
/*! tailwindcss v2.2.16 | MIT License | https://tailwindcss.com *//*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

/*
Document
========
*/

/**
Use a better box model (opinionated).
*/

*,
::before,
::after {
	box-sizing: border-box;
}

/**
Use a more readable tab size (opinionated).
*/

html {
	-moz-tab-size: 4;
	-o-tab-size: 4;
	   tab-size: 4;
}

/**
1. Correct the line height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
*/

html {
	line-height: 1.15; /* 1 */
	-webkit-text-size-adjust: 100%; /* 2 */
}

/*
Sections
========
*/

/**
Remove the margin in all browsers.
*/

body {
	margin: 0;
}

/**
Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
*/

body {
	font-family:
		system-ui,
		-apple-system, /* Firefox supports this but not yet \`system-ui\` */
		'Segoe UI',
		Roboto,
		Helvetica,
		Arial,
		sans-serif,
		'Apple Color Emoji',
		'Segoe UI Emoji';
}

/*
Grouping content
================
*/

/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
*/

hr {
	height: 0; /* 1 */
	color: inherit; /* 2 */
}

/*
Text-level semantics
====================
*/

/**
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr[title] {
	-webkit-text-decoration: underline dotted;
	        text-decoration: underline dotted;
}

/**
Add the correct font weight in Edge and Safari.
*/

b,
strong {
	font-weight: bolder;
}

/**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. Correct the odd 'em' font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
	font-family:
		ui-monospace,
		SFMono-Regular,
		Consolas,
		'Liberation Mono',
		Menlo,
		monospace; /* 1 */
	font-size: 1em; /* 2 */
}

/**
Add the correct font size in all browsers.
*/

small {
	font-size: 80%;
}

/**
Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
*/

sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

/*
Tabular data
============
*/

/**
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
*/

table {
	text-indent: 0; /* 1 */
	border-color: inherit; /* 2 */
}

/*
Forms
=====
*/

/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/

button,
input,
optgroup,
select,
textarea {
	font-family: inherit; /* 1 */
	font-size: 100%; /* 1 */
	line-height: 1.15; /* 1 */
	margin: 0; /* 2 */
}

/**
Remove the inheritance of text transform in Edge and Firefox.
1. Remove the inheritance of text transform in Firefox.
*/

button,
select { /* 1 */
	text-transform: none;
}

/**
Correct the inability to style clickable types in iOS and Safari.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
	-webkit-appearance: button;
}

/**
Remove the inner border and padding in Firefox.
*/

::-moz-focus-inner {
	border-style: none;
	padding: 0;
}

/**
Restore the focus styles unset by the previous rule.
*/

:-moz-focusring {
	outline: 1px dotted ButtonText;
}

/**
Remove the additional ':invalid' styles in Firefox.
See: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737
*/

:-moz-ui-invalid {
	box-shadow: none;
}

/**
Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
*/

legend {
	padding: 0;
}

/**
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
	vertical-align: baseline;
}

/**
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}

/**
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
	-webkit-appearance: textfield; /* 1 */
	outline-offset: -2px; /* 2 */
}

/**
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
	-webkit-appearance: none;
}

/**
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to 'inherit' in Safari.
*/

::-webkit-file-upload-button {
	-webkit-appearance: button; /* 1 */
	font: inherit; /* 2 */
}

/*
Interactive
===========
*/

/*
Add the correct display in Chrome and Safari.
*/

summary {
	display: list-item;
}/**
 * Manually forked from SUIT CSS Base: https://github.com/suitcss/base
 * A thin layer on top of normalize.css that provides a starting point more
 * suitable for web applications.
 */

/**
 * Removes the default spacing and border for appropriate elements.
 */

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

button {
  background-color: transparent;
  background-image: none;
}

fieldset {
  margin: 0;
  padding: 0;
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/**
 * Tailwind custom reset styles
 */

/**
 * 1. Use the user's configured \`sans\` font-family (with Tailwind's default
 *    sans-serif font stack as a fallback) as a sane default.
 * 2. Use Tailwind's default "normal" line-height so the user isn't forced
 *    to override it to ensure consistency even when using the default theme.
 */

html {
  font-family: Lato, sans-serif; /* 1 */
  line-height: 1.5; /* 2 */
}


/**
 * Inherit font-family and line-height from \`html\` so users can set them as
 * a class directly on the \`html\` element.
 */

body {
  font-family: inherit;
  line-height: inherit;
}

/**
 * 1. Prevent padding and border from affecting element width.
 *
 *    We used to set this in the html element and inherit from
 *    the parent element for everything else. This caused issues
 *    in shadow-dom-enhanced elements like <details> where the content
 *    is wrapped by a div with box-sizing set to \`content-box\`.
 *
 *    https://github.com/mozdevs/cssremedy/issues/4
 *
 *
 * 2. Allow adding a border to an element by just adding a border-width.
 *
 *    By default, the way the browser specifies that an element should have no
 *    border is by setting it's border-style to \`none\` in the user-agent
 *    stylesheet.
 *
 *    In order to easily add borders to elements by just setting the \`border-width\`
 *    property, we change the default border-style for all elements to \`solid\`, and
 *    use border-width to hide them instead. This way our \`border\` utilities only
 *    need to set the \`border-width\` property instead of the entire \`border\`
 *    shorthand, making our border utilities much more straightforward to compose.
 *
 *    https://github.com/tailwindcss/tailwindcss/pull/116
 */

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

/*
 * Ensure horizontal rules are visible by default
 */

hr {
  border-top-width: 1px;
}

/**
 * Undo the \`border-style: none\` reset that Normalize applies to images so that
 * our \`border-{width}\` utilities have the expected effect.
 *
 * The Normalize reset is unnecessary for us since we default the border-width
 * to 0 on all elements.
 *
 * https://github.com/tailwindcss/tailwindcss/issues/362
 */

img {
  border-style: solid;
}

textarea {
  resize: vertical;
}

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  color: #a1a1aa;
}

input:-ms-input-placeholder, textarea:-ms-input-placeholder {
  opacity: 1;
  color: #a1a1aa;
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  color: #a1a1aa;
}

button,
[role="button"] {
  cursor: pointer;
}

/**
 * Override legacy focus reset from Normalize with modern Firefox focus styles.
 *
 * This is actually an improvement over the new defaults in Firefox in our testing,
 * as it triggers the better focus styles even for links, which still use a dotted
 * outline in Firefox by default.
 */
 
:-moz-focusring {
	outline: auto;
}

table {
  border-collapse: collapse;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/**
 * Reset links to optimize for opt-in styling instead of
 * opt-out.
 */

a {
  color: inherit;
  text-decoration: inherit;
}

/**
 * Reset form element properties that are easy to forget to
 * style explicitly so you don't inadvertently introduce
 * styles that deviate from your design system. These styles
 * supplement a partial reset that is already applied by
 * normalize.css.
 */

button,
input,
optgroup,
select,
textarea {
  padding: 0;
  line-height: inherit;
  color: inherit;
}

/**
 * Use the configured 'mono' font family for elements that
 * are expected to be rendered with a monospace font, falling
 * back to the system monospace stack if there is no configured
 * 'mono' font family.
 */

pre,
code,
kbd,
samp {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

/**
 * 1. Make replaced elements \`display: block\` by default as that's
 *    the behavior you want almost all of the time. Inspired by
 *    CSS Remedy, with \`svg\` added as well.
 *
 *    https://github.com/mozdevs/cssremedy/issues/14
 * 
 * 2. Add \`vertical-align: middle\` to align replaced elements more
 *    sensibly by default when overriding \`display\` by adding a
 *    utility like \`inline\`.
 *
 *    This can trigger a poorly considered linting error in some
 *    tools but is included by design.
 * 
 *    https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210
 */

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/**
 * Constrain images and videos to the parent width and preserve
 * their intrinsic aspect ratio.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */

img,
video {
  max-width: 100%;
  height: auto;
}

/**
 * Ensure the default browser behavior of the \`hidden\` attribute.
 */

[hidden] {
  display: none;
}

*, ::before, ::after {
	border-color: currentColor;
}
  ul {
	margin: 0px;
	list-style-type: none;
}

  a {
    text-decoration: none;
  }

  *,
  ::after,
  ::before {
    box-sizing: border-box;
    border: 0 solid;
  }

  @media (min-width: 640px) {

	.sm\:absolute {
		position: absolute;
	}

	.sm\:top-1\/2 {
		top: 50%;
	}

	.sm\:order-1 {
		order: 1;
	}

	.sm\:order-3 {
		order: 3;
	}

	.sm\:ml-3\/10 {
		margin-left: 30%;
	}

	.sm\:mr-0 {
		margin-right: 0px;
	}

	.sm\:mr-14 {
		margin-right: 3.5rem;
	}

	.sm\:ml-6 {
		margin-left: 1.5rem;
	}

	.sm\:h-full {
		height: 100%;
	}

	.sm\:max-h-2\/3 {
		max-height: 66%;
	}

	.sm\:w-auto {
		width: auto;
	}

	.sm\:w-7\/10 {
		width: 70%;
	}

	.sm\:grid-cols-2 {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.sm\:gap-x-4 {
		-moz-column-gap: 1rem;
		     column-gap: 1rem;
	}

	.sm\:p-6 {
		padding: 1.5rem;
	}

	.sm\:p-0 {
		padding: 0px;
	}

	.sm\:py-12 {
		padding-top: 3rem;
		padding-bottom: 3rem;
	}

	.sm\:pt-3 {
		padding-top: 0.75rem;
	}

	.sm\:pt-0 {
		padding-top: 0px;
	}

	.sm\:text-left {
		text-align: left;
	}

	.sm\:text-xs {
		font-size: 0.875rem;
	}

	.sm\:text-lg {
		font-size: 1.125rem;
	}
}

  @media (min-width: 768px) {

	.md\:absolute {
		position: absolute;
	}

	.md\:relative {
		position: relative;
	}

	.md\:right-0 {
		right: 0px;
	}

	.md\:top-0 {
		top: 0px;
	}

	.md\:-z-10 {
		z-index: -10;
	}

	.md\:mr-3 {
		margin-right: 0.75rem;
	}

	.md\:-mt-32 {
		margin-top: -8rem;
	}

	.md\:mb-3 {
		margin-bottom: 0.75rem;
	}

	.md\:mr-4 {
		margin-right: 1rem;
	}

	.md\:mt-8 {
		margin-top: 2rem;
	}

	.md\:flex {
		display: flex;
	}

	.md\:grid {
		display: grid;
	}

	.md\:h-full {
		height: 100%;
	}

	.md\:h-40 {
		height: 10rem;
	}

	.md\:w-8 {
		width: 2rem;
	}

	.md\:w-5 {
		width: 1.25rem;
	}

	.md\:w-40 {
		width: 10rem;
	}

	.md\:flex-none {
		flex: none;
	}

	.md\:grid-cols-3 {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.md\:grid-cols-2 {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.md\:grid-cols-4 {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}

	.md\:flex-row {
		flex-direction: row;
	}

	.md\:flex-col {
		flex-direction: column;
	}

	.md\:items-center {
		align-items: center;
	}

	.md\:justify-start {
		justify-content: flex-start;
	}

	.md\:justify-between {
		justify-content: space-between;
	}

	.md\:gap-x-24 {
		-moz-column-gap: 6rem;
		     column-gap: 6rem;
	}

	.md\:gap-x-8 {
		-moz-column-gap: 2rem;
		     column-gap: 2rem;
	}

	.md\:border-b {
		border-bottom-width: 1px;
	}

	.md\:border-r {
		border-right-width: 1px;
	}

	.md\:border-white {
		--tw-border-opacity: 1;
		border-color: rgba(255, 255, 255, var(--tw-border-opacity));
	}

	.md\:bg-white {
		--tw-bg-opacity: 1;
		background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
	}

	.md\:bg-purple {
		--tw-bg-opacity: 1;
		background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
	}

	.md\:fill-current {
		fill: currentColor;
	}

	.md\:py-5 {
		padding-top: 1.25rem;
		padding-bottom: 1.25rem;
	}

	.md\:px-8 {
		padding-left: 2rem;
		padding-right: 2rem;
	}

	.md\:px-4 {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.md\:py-6 {
		padding-top: 1.5rem;
		padding-bottom: 1.5rem;
	}

	.md\:pl-8 {
		padding-left: 2rem;
	}

	.md\:pr-12 {
		padding-right: 3rem;
	}

	.md\:pr-6 {
		padding-right: 1.5rem;
	}

	.md\:pl-6 {
		padding-left: 1.5rem;
	}

	.md\:pt-5 {
		padding-top: 1.25rem;
	}

	.md\:pl-10 {
		padding-left: 2.5rem;
	}

	.md\:pb-0 {
		padding-bottom: 0px;
	}

	.md\:text-xs {
		font-size: 0.875rem;
	}

	.md\:text-base {
		font-size: 1rem;
	}

	.md\:font-bold {
		font-weight: 700;
	}

	.md\:text-white {
		--tw-text-opacity: 1;
		color: rgba(255, 255, 255, var(--tw-text-opacity));
	}
}

  @media (min-width: 1024px) {

	.lg\:static {
		position: static;
	}

	.lg\:fixed {
		position: fixed;
	}

	.lg\:absolute {
		position: absolute;
	}

	.lg\:relative {
		position: relative;
	}

	.lg\:-left-6 {
		left: -1.5rem;
	}

	.lg\:top-0 {
		top: 0px;
	}

	.lg\:left-0 {
		left: 0px;
	}

	.lg\:bottom-0 {
		bottom: 0px;
	}

	.lg\:bottom-4 {
		bottom: 1rem;
	}

	.lg\:-z-10 {
		z-index: -10;
	}

	.lg\:mx-0 {
		margin-left: 0px;
		margin-right: 0px;
	}

	.lg\:my-20 {
		margin-top: 5rem;
		margin-bottom: 5rem;
	}

	.lg\:mt-2 {
		margin-top: 0.5rem;
	}

	.lg\:mt-flush-header {
		margin-top: -112px;
	}

	.lg\:ml-56 {
		margin-left: 14rem;
	}

	.lg\:mt-0 {
		margin-top: 0px;
	}

	.lg\:ml-10 {
		margin-left: 2.5rem;
	}

	.lg\:mr-28 {
		margin-right: 7rem;
	}

	.lg\:mb-0 {
		margin-bottom: 0px;
	}

	.lg\:-mb-12 {
		margin-bottom: -3rem;
	}

	.lg\:mt-8 {
		margin-top: 2rem;
	}

	.lg\:block {
		display: block;
	}

	.lg\:inline-block {
		display: inline-block;
	}

	.lg\:flex {
		display: flex;
	}

	.lg\:grid {
		display: grid;
	}

	.lg\:h-full {
		height: 100%;
	}

	.lg\:h-screen {
		height: 100vh;
	}

	.lg\:h-auto {
		height: auto;
	}

	.lg\:h-22 {
		height: 5.5rem;
	}

	.lg\:h-48 {
		height: 12rem;
	}

	.lg\:w-screen {
		width: 100vw;
	}

	.lg\:w-full {
		width: 100%;
	}

	.lg\:w-22 {
		width: 5.5rem;
	}

	.lg\:w-12 {
		width: 3rem;
	}

	.lg\:w-48 {
		width: 12rem;
	}

	.lg\:w-px {
		width: 1px;
	}

	.lg\:w-auto {
		width: auto;
	}

	.lg\:w-18 {
		width: 4.5rem;
	}

	.lg\:w-6 {
		width: 1.5rem;
	}

	.lg\:max-w-screen-lg {
		max-width: 1024px;
	}

	.lg\:max-w-none {
		max-width: none;
	}

	.lg\:flex-row {
		flex-direction: row;
	}

	.lg\:flex-col {
		flex-direction: column;
	}

	.lg\:flex-wrap {
		flex-wrap: wrap;
	}

	.lg\:items-center {
		align-items: center;
	}

	.lg\:justify-start {
		justify-content: flex-start;
	}

	.lg\:justify-center {
		justify-content: center;
	}

	.lg\:self-start {
		align-self: flex-start;
	}

	.lg\:border-0 {
		border-width: 0px;
	}

	.lg\:border-r {
		border-right-width: 1px;
	}

	.lg\:border-t {
		border-top-width: 1px;
	}

	.lg\:border-b {
		border-bottom-width: 1px;
	}

	.lg\:border-l {
		border-left-width: 1px;
	}

	.lg\:border-light-outline-purple {
		--tw-border-opacity: 1;
		border-color: rgba(109, 89, 149, var(--tw-border-opacity));
	}

	.lg\:bg-purple {
		--tw-bg-opacity: 1;
		background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
	}

	.lg\:bg-light-outline-gray {
		--tw-bg-opacity: 1;
		background-color: rgba(216, 216, 216, var(--tw-bg-opacity));
	}

	.lg\:px-0 {
		padding-left: 0px;
		padding-right: 0px;
	}

	.lg\:px-1 {
		padding-left: 0.25rem;
		padding-right: 0.25rem;
	}

	.lg\:px-6 {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}

	.lg\:px-4 {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.lg\:pb-0 {
		padding-bottom: 0px;
	}

	.lg\:pl-6 {
		padding-left: 1.5rem;
	}

	.lg\:pt-5 {
		padding-top: 1.25rem;
	}

	.lg\:pt-0 {
		padding-top: 0px;
	}

	.lg\:pr-6 {
		padding-right: 1.5rem;
	}

	.lg\:pl-34 {
		padding-left: 8.5rem;
	}

	.lg\:pr-8 {
		padding-right: 2rem;
	}

	.lg\:pb-4 {
		padding-bottom: 1rem;
	}

	.lg\:font-sans {
		font-family: Lato, sans-serif;
	}

	.lg\:text-xl {
		font-size: 1.25rem;
	}

	.lg\:text-8xl {
		font-size: 2.8125rem;
	}

	.lg\:text-5xl {
		font-size: 1.75rem;
	}

	.lg\:text-base {
		font-size: 1rem;
	}

	.lg\:text-7xl {
		font-size: 2.5rem;
	}

	.lg\:text-2xl {
		font-size: 1.375rem;
	}

	.lg\:font-bold {
		font-weight: 700;
	}

	.lg\:leading-header-snug {
		line-height: 1.15;
	}

	.lg\:leading-normal {
		line-height: 1.5;
	}

	.lg\:tracking-tighter {
		letter-spacing: -0.046875rem;
	}

	.lg\:tracking-wider {
		letter-spacing: 0.125rem;
	}

	.lg\:tracking-wide {
		letter-spacing: 0.0625rem;
	}

	.lg\:text-dark-gray {
		--tw-text-opacity: 1;
		color: rgba(35, 35, 35, var(--tw-text-opacity));
	}
}

  @media (min-width: 1200px) {

	.xl\:absolute {
		position: absolute;
	}

	.xl\:top-0 {
		top: 0px;
	}

	.xl\:left-1\/2 {
		left: 50%;
	}

	.xl\:right-1\/2 {
		right: 50%;
	}

	.xl\:-left-12 {
		left: -3rem;
	}

	.xl\:my-20 {
		margin-top: 5rem;
		margin-bottom: 5rem;
	}

	.xl\:mt-16 {
		margin-top: 4rem;
	}

	.xl\:flex {
		display: flex;
	}

	.xl\:grid {
		display: grid;
	}

	.xl\:h-24 {
		height: 6rem;
	}

	.xl\:h-auto {
		height: auto;
	}

	.xl\:max-w-screen-xl {
		max-width: 1200px;
	}

	.xl\:px-3 {
		padding-left: 0.75rem;
		padding-right: 0.75rem;
	}

	.xl\:pr-8 {
		padding-right: 2rem;
	}

	.xl\:pl-8 {
		padding-left: 2rem;
	}

	.xl\:pl-16 {
		padding-left: 4rem;
	}

	.xl\:pt-0 {
		padding-top: 0px;
	}
}

  @media (min-width: 1366px) {

	.xxl\:grid-cols-4 {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}

	.xxl\:text-sm {
		font-size: 0.9375rem;
	}
}

  @media (max-width: 1023px) {

	.md-down\:fixed {
		position: fixed;
	}

	.md-down\:top-0 {
		top: 0px;
	}

	.md-down\:left-0 {
		left: 0px;
	}

	.md-down\:h-full {
		height: 100%;
	}

	.md-down\:w-full {
		width: 100%;
	}

	.md-down\:overflow-auto {
		overflow: auto;
	}

	.md-down\:bg-white {
		--tw-bg-opacity: 1;
		background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
	}

	.md-down\:p-6 {
		padding: 1.5rem;
	}
}

  @media (max-width: 767px) {

	.sm-down\:top-0 {
		top: 0px;
	}
}
`;